import intlTelInput from 'intl-tel-input';
import Inputmask from "inputmask";
import moment from 'moment'

import 'intl-tel-input/build/css/intlTelInput.css';
const tel = $('input[type="tel"]')[0];
const input = intlTelInput(tel, { preferredCountries: ['by', 'ua', 'ru'] });
let inputmask = Inputmask({
    mask: input.selectedCountryData.dialCode + "9{1,}"
}).mask(tel);

tel.addEventListener("countrychange", function() {
    inputmask.remove()
    inputmask = Inputmask({
        mask: input.selectedCountryData.dialCode + "9{1,}"
    }).mask(tel);
});


function valid(el){
    el.next('.error').remove();
    el.removeClass('error');
    if(!el.val()){
        el.addClass('error');
        $('<span class="error">Поле обязательное для заполнения</span>').appendTo(el.closest('label'))
    } else if(el.attr('name') === 'email'){
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(String(el.val()).toLowerCase())){
            el.addClass('error');
            $('<span class="error">Укажите свой почтовый ящик</span>').appendTo(el.closest('label'))
        }
    } else if(el.attr('name') === 'rules') {
        if(!el.is(':checked')) {
            $('label.checkbox').addClass('error');
        } else {
            $('label.checkbox').removeClass('error')
        }
    }
    return el.val();
}

$('.btn-primary[type="submit"]').on('click', function (e){
    e.preventDefault();
    let data = {};
    $('.form-input').removeClass('error').each(function(){
        $(this).closest('label').find('span.error').remove();
        data[$(this).attr('name')] = valid($(this))
    });

    if(!$('.form-input.error').length){
        fetch('https://api.teachmeskills.by/api/form', {
            method: 'POST',
            body: JSON.stringify(data)
        }).then(() => {
            $('.msg-success').addClass('open')
        }).catch(err => {
            console.log(err)
        }).finally(() => {
            $('.form form')[0].reset();
        })
    }
})

$('.form-input').on('focus', function(){
    $(this).closest('label').find('span.error').remove();
    $(this).removeClass('error');

})
$('input[type="checkbox"]').on('change', function () {
    $('label.checkbox').removeClass('error')
})
$('.form-input').on('blur', function(){
    valid($(this));
});
$('.form-input.only-str').on('keypress', function (event){
    const regex = new RegExp("^[a-zA-Zа-яА-Я ]+$");
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
})
$('.form-input.only-num').on('keypress', function (event){
    const regex = new RegExp(/[0-9]|\./);
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
})
$('.btn-primary.scroll').on('click', function(){
    $('html, body').animate({'scrollTop': $('.form').offset().top})
})

$('.msg-success-close').on('click', function (){
    $('.msg-success').removeClass('open')
})

function diffSubtract(date1, date2) {
    return date2 - date1;
}

let end_date = {
    "full_year": "2021", // Год
    "month": "12", // Номер месяца
    "day": "24", // День
    "hours": "23", // Час
    "minutes": "59", // Минуты
    "seconds": "59" // Секунды
}

let end_date_str = `${end_date.full_year}-${end_date.month}-${end_date.day}T${end_date.hours}:${end_date.minutes}:${end_date.seconds}`;

let timer = setInterval(function () {
    let now = new Date();
    let date = new Date(end_date_str);
    let ms_left = diffSubtract(now, date);
    if (ms_left <= 0) {
        clearInterval(timer);
        alert("Время закончилось");
    } else {
        let res = new Date(ms_left);
        $('.time.days').text(res.getUTCDate() - 1)
        $('.time.hours').text(res.getUTCHours())
        $('.time.minutes').text(res.getUTCMinutes())
        $('.time.seconds').text(res.getUTCSeconds())
    }
}, 1000)